<ng-container *transloco="let t">
  <div class="d-flex flex-column">
    <div class="event-grid-item" [class.is-last]="isLast">
      <app-event-list-item-header [eventItem]="eventItem"
                                  [languages]="languages"
                                  [defaultLanguage]="eventItem?.defaultLanguage"/>
      <div class="event-grid-item--body">
        <div class="item-info d-flex">
          <div class="event-image-wrapper">
            <div class="position-relative h-100">
              @if (eventItem?.imageMedium !== null) {
                <img src="{{eventItem!.imageMedium}}" alt="" class="bck-img" appImageFallback>
              }
              @if (eventItem?.imageMedium === null) {
                <img src="{{environment.assetsImagesPath + '/assets/img/hiker.png'}}" alt="" class="bck-img" appImageFallback>
              }
              @if (eventItem?.status === EventStatus.FINISHED) {
                <div class="img-overlay"></div>
              }
              <div class="round-wrapper text-uppercase"
                   [class.finished-event]="eventItem?.status === EventStatus.FINISHED">
                <span>{{ eventItem | leagueRound:league | uppercase }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-end w-100">
            <div class="d-flex flex-column h-100 justify-content-between">
              <div class="event-date-wrapper" [class.finished-event]="eventItem?.status === EventStatus.FINISHED">
                <span class="text-uppercase pe-1"
                      [innerHTML]="eventItem && eventItem.start ? formatDate(eventItem!.start!) : ''"></span>
                <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'d') : '-'"></span>
                @if (checkSameDate(eventItem)) {
                  <div>
                    -
                    <span [innerHTML]="eventItem && eventItem.end ? (eventItem!.end | date:'d') : '-'"></span>
                  </div>
                }
                <span>,&nbsp;</span>
                <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'yyyy') : '-'"></span>
              </div>
              <div class="details-grid">
                <div class="location-wrapper mt-3 mt-xl-0">
                  @if (eventItem?.city || eventItem?.country) {
                    <img src="assets/icons/location-icon.svg" alt="Running" class="card-body__icon" height="28"/>
                  }
                  <span>
                  {{ eventItem?.city }}
                </span>
                  @if (eventItem?.country) {
                    <span>{{ ',' }}</span>
                  }
                  @if (eventCountry?.shortCode) {
                    <span class="ps-1">{{ eventCountry?.shortCode }}</span>
                  }
                </div>
                <div class="lengths-wrapper">
                  <img src="assets/icons/location-icon-alt.svg" alt="Running" class="card-body__icon" height="28"/>
                  <div class="race-lengths">
                    @for (length of lengths; track length; let idx = $index) {
                      <div class="race-lengths__item">
                        {{ length | raceLengthFormat:translocoService.getActiveLang() }}
                      </div>
                    }
                  </div>
                </div>
                <div class="finished-wrapper d-flex align-items-end" *ngIf="eventItem?.status === EventStatus.FINISHED">
                  <div class="image-box">
                    <img src="assets/img/svg/finished-participants.svg"
                         [alt]="t('events.finished.events.finished.participants')" height="28">
                  </div>
                  <span class="me-8"> {{ t("events.finished.events.finished.participants") }}:</span>
                  <app-badge [label]="eventItem?.finCompetitorCnt ?? 0"/>
                </div>
                <div class="countries-wrapper d-flex align-items-end"
                     *ngIf="eventItem?.status === EventStatus.FINISHED">
                  <div class="image-box">
                    <img src="assets/img/svg/flag.svg" [alt]="t('events.finished.events.countries')"
                         height="28">
                  </div>
                  <span class="me-8"> {{ t("events.finished.events.countries") }}:</span>
                  <app-badge [label]="eventItem?.competitorCountriesCnt ?? 0"/>
                </div>
              </div>
              <ng-container *ngIf="eventItem?.status === EventStatus.FINISHED; else showFirstButton">
                <div class="mt-3 mt-xl-0">
                  <app-rounded-button (click)="openEventDetails()" [label]="'#' + t('events.details.results')"
                                      [btnClass]="'rounded-button--black-outline'"></app-rounded-button>
                </div>
              </ng-container>
              <ng-template #showFirstButton>
                <div class="mt-3 mt-xl-0">
                  <app-rounded-button (click)="openEventDetails()" [label]="t('event.race.it')"></app-rounded-button>
                </div>
              </ng-template>
            </div>
            <div class="d-flex flex-nowrap">
              <img src="assets/icons/red-outlined-heart.svg" alt="Heart"/></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
